const Microsoft365 = () => {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
        >
            <path fill="#F25022" d="M11.505 2H2v9.64h9.505V2Z" />
            <path fill="#7FBA00" d="M22 2h-9.505v9.64H22V2Z" />
            <path fill="#00A4EF" d="M11.505 12.648H2v9.64h9.505v-9.64Z" />
            <path fill="#FFB900" d="M22 12.648h-9.505v9.64H22v-9.64Z" />
        </svg>
    );
};

export default Microsoft365;
